import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private modalService: NgbModal) {}

  openModal(modalContent: any) {
    const modalRef = this.modalService.open(modalContent);
    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
      },
      (reason) => {
        console.log('Modal dismissed', reason);
      }
    );
    return modalRef;
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
